<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="title">雷士照明2025高潜人才评估</div>
      <div class="login-box">
        <van-field
          v-model="nickName"
          clearable
          placeholder="请输入姓名"
        />
        <van-field
          v-model="username"
          clearable
          placeholder="请输入工号"
        />
        <van-button
          type="primary"
          block
          @click="login"
          style="margin-top: 30px; border-radius: 10px"
          >登录</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/evaluation";
export default {
  data() {
    return {
      username: "",
      nickName: "",
    };
  },
  methods: {
    // 登录
    login() {
      if (!this.nickName) return this.$message.error("请输入姓名");
      if (!this.username) return this.$message.error("请输入工号");
      let obj = {};
      api
        .userFindUserAndName({
          username: this.username,
          nickName: this.nickName,
        })
        .then((res) => {
          if (res.code == 200) {
            obj = res.data;
            sessionStorage.setItem("loginEvaluation", JSON.stringify(obj));
            this.$router.push("/evaluation");
          }
        });
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 306px * $zoom;
    ::v-deep {
      .van-dropdown-item {
        width: 306px * $zoom !important;
        margin: auto;
      }
    }
  }
}

.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}

.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: hidden;
  padding-top: 40px;
  background: url("~@/assets/evaluation/bg.png") no-repeat;
  background-size: 100% 100%;
  .title {
    text-align: center;
    padding: 45% 0 15%;
    font-size: 48px;
  }
}

.login-box {
  width: 80%;
  margin: 0 auto;
}

.login-title {
  text-align: center;
  margin-bottom: 15px;
  font-size: 17px;
  font-weight: bold;
}

.captcha-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.captcha-btn {
  margin-left: 10px;
  flex-shrink: 0;
}
</style>
